const News = () => {
  return <div>ss</div>;
};
export default News;
